import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfDigitalWorkingHoursScoreGoalService } from '../../../core/application/services/goals/get-self-digital-working-hours-score-goal.service';
import { SelfDigitalWorkingHoursScoreGoalEntity } from '../../../core/domain/entities/goals/score-goals/self-digital-working-hours-score-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfDigitalWorkingHoursScoreGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfDigitalWorkingHoursScoreGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfDigitalWorkingHoursScoreGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
